export default "__VITE_ASSET__CFNvcneQ__"